<script setup lang="ts">
import View from '~/pages-components/blog/detail.vue'
</script>

<template>
  <div>
    <View />
  </div>
</template>
